import { createBrowserRouter } from "react-router-dom";
import App from '../App'
import Home from "./Home";
import About from "../pages/About";
import Contact from '../pages/Contact';
import AboutRight from "../pages/AboutRight";
import BackgroundParticles from "../components/BackgroundParticles";
import MainPage from "../components/MainPage";
import Services from "../pages/Services";
import Blog from "../pages/Blog";
import OurClient from "../pages/OurCients";
import WhyChoose from "../pages/WhyChoose";
import Whatwedo from "../pages/Whatwedo";
import Industries from "../pages/Industries";
import GridDesign from "../pages/GridDesign";
import LayoutDesign from "../pages/LayoutDesign";
import OurWork from "../pages/OurWork";
import Enquiry from "../pages/Enquiry";
import WhyDigital from "../pages/WhyDigital";
import AdminPanel from "../components/AdminPanel";
import BlogDetail from "../pages/BlogDetail";
import BannerPages from "../pages/BannerPages";

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      { path: "", element: <Home /> },
      { path: "/About", element: <About /> },
      { path: "/Contact", element: <Contact/> },
      { path: "/AboutRight", element: <AboutRight/> },
      { path: "/BackgroundParticles", element: <BackgroundParticles/> },
      { path: "/MainPage", element: <MainPage/> },
      { path: "/Services", element: <Services/> },
      { path: "/blog", element: <Blog/> },
      { path: "/OurClient", element: <OurClient/> },
      { path: "/WhyChoose", element: <WhyChoose/> },
      { path: "/Whatwedo", element: <Whatwedo/> },
      { path: "/Industries", element: <Industries/> },
      { path: "/GridDesign", element: <GridDesign/> },
      { path: "/LayoutDesign", element: <LayoutDesign/> },
      { path: "/OurWork", element: <OurWork/> },
      { path: "/Enquiry", element: <Enquiry/> },
      { path: "/WhyDigital", element: <WhyDigital/> },
      { path: "/AdminPanel", element: <AdminPanel/> },
      { path: "/blog/:id", element: <BlogDetail/> },
      { path: "BannerPages", element: <BannerPages/> },
    ]
  }]);
export default router;